// extracted by mini-css-extract-plugin
export default {"ldsEllipsis":"Loader_ldsEllipsis__bVqy9","ldsEllipsis1":"Loader_ldsEllipsis1__0JHhL","ldsEllipsis2":"Loader_ldsEllipsis2__SaXDD","ldsEllipsis3":"Loader_ldsEllipsis3__sxskD"};